import postscribe from 'postscribe'
import axios from '@/plugins/axios'

export default {
  cardToken: true,
  init (estico, sandbox) {
    return new Promise((resolve, reject) => {
      const element = document.getElementById('payments')
      const url = {
        sandbox: '<script type="text/javascript" src="https://stc.sandbox.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js"></script>',
        production: '<script type="text/javascript" src="https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js"></script>'
      }
      const pagseguro = this
      const callback = {
        done: function () {
          axios.get('payment/pagseguro/' + estico).then((response) => {
            window.PagSeguroDirectPayment.setSessionId(response.data.id)
            pagseguro.senderHash()
            resolve(true)
          })
        },
        error: function (response) {
          // Callback para chamadas que falharam.
          reject(response)
        }
      }
      postscribe(element, sandbox ? url.sandbox : url.production, callback)
    })
  },
  async senderHash () {
    return new Promise((resolve, reject) => {
      window.PagSeguroDirectPayment.onSenderHashReady(function (sender) {
        window.payment.senderHash = sender.senderHash
        console.log('Sender Hash - created')
        resolve()
      })
    })
  },
  async token (card) {
    const brand = await this.getBrand(card.number)
    const expiration = card.dueDate.split('/')
    return new Promise((resolve, reject) => {
      window.PagSeguroDirectPayment.createCardToken({
        cardNumber: card.number.replace(/\D/g, ''), // Número do cartão de crédito
        brand: brand.name, // Bandeira do cartão
        cvv: card.cvv, // CVV do cartão
        expirationMonth: expiration[0], // Mês da expiração do cartão
        expirationYear: `20${expiration[1]}`, // Ano da expiração do cartão, é necessário os 4 dígitos.
        success: function (response) {
          // Retorna o cartão tokenizado.
          resolve(response.card.token)
        },
        error: function (response) {
          // Callback para chamadas que falharam.
          reject(response)
        },
        complete: function (response) {
          // Callback para todas chamadas.
        }
      })
    })
  },
  async getBrand (cardNumber) {
    return new Promise((resolve, reject) => {
      window.PagSeguroDirectPayment.getBrand({
        cardBin: cardNumber.replace(/\D/g, ''),
        success: function (response) {
          resolve(response.brand)
        },
        error: function (response) {
        },
        complete: function (response) {
        }
      })
    })
  },
  async getInstallments (estico, card) {
    return new Promise((resolve, reject) => {
      this.getBrand(card.number).then((response) => {
        const brand = response.name
        window.PagSeguroDirectPayment.getInstallments({
          amount: card.total,
          maxInstallmentNoInterest: 2,
          brand: brand,
          success: function (response) {
            const installments = []
            response.installments[brand].forEach(element => {
              installments.push({
                value: JSON.stringify(element),
                text: `${element.quantity}x de ${element.installmentAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} ${element.interestFree ? 'sem juros' : 'com juros'}`
              })
            })
            resolve(installments)
          },
          error: function (response) {
            reject(response)
          },
          complete: function (response) {
          }
        })
      })
    })
  }
}
